import { API } from '../helpers/fetcher'

export const getPaymentQrCode = () => API.getImage('v1/transaction/qr-code')
